import * as React from 'react';

import { useStaticQuery, graphql } from 'gatsby';
import useLiveData from 'hooks/useLiveData';
import { Typography, Box, Container, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import Link from 'components/Link';
import theme from 'utils/theme';
import MobileMenu from 'components/MobileMenu';

import logo from 'images/logo.svg';
import menu from 'images/menu.svg';

const Header = (props) => {
	const data = useStaticQuery(graphql`
		query headerMenu {
		  allMainMenu:allContentMenu (filter: {menuID: {eq: "main"}}) {
		    edges {
		      node {
		        pages
		      }
		    }
		  }
		}
	`);
	const { response } = useLiveData({
		type: 'ContentMenu',
		method: 'all',
		apiParams: {
			menuID: 'main',
		},
		graphqlKey: 'allMainMenu',
		staticData: data,
	});

	const navigationStyle = {
		display: {
			xs: 'none',
			sm: 'block',
		},
		height: {
			sm: '100%'
		}
	}

	const logoStyle = {
		textAlign: {
			xs: 'center',
			sm: 'left',
		}
	}

	// const [showOffCanvas, setShowOffCanvas] = React.useState(false);
	const [showMobileMenu, setShowMobileMenu] = React.useState(false);
	const [anchorEl, setAnchorEl] = React.useState(null);

	const closeMenu = () => {
		setShowMobileMenu(false);
		setAnchorEl(null);
	}

	const toggleMobileMenu = (evt) => {
		setAnchorEl((showMobileMenu ? null : evt.currentTarget));
		setShowMobileMenu(!showMobileMenu);
	}

	const mainLinks = response.data[0].pages.filter(item => {
		if (item.visible === 'true' || item.visible === true)return true;
		return false;
	});

	const style = {
		...theme.palette.header,
		position: 'relative',
	}

	const menuButtonStyle = {
		display: {
			xs: 'block',
			sm: 'none',
		},
		position: 'absolute',
		top: '50%',
		right: '3%',
		transform: 'translateY(-50%)',
	}

	return (
		<>
		<header>
			<Box sx={style}>
				<Button sx={menuButtonStyle} onClick={toggleMobileMenu} variant="silent"><img src={menu} alt="Open navigation menu." /></Button>
				<Container>
					<Grid container alignItems="stretch">
						<Grid xs={12} sm={4}>
							<Box sx={logoStyle}>
								<Link href="/" className="logo"><img src={logo} alt="" /></Link>
							</Box>
						</Grid>
						<Grid sm={8} sx={{paddingTop: '0px', paddingBottom: '0px'}}>
							<Box sx={navigationStyle}>
								<nav className="main-nav">
									<ul className="primaryNav">
										{mainLinks.length && mainLinks.map((item, index) => {
											let submenuLinks = []
											if (item.hasOwnProperty("children")) submenuLinks = item.children
											if (!JSON.parse(item.visible)) return null;
											return (
												<li key={index} className={(item.hasOwnProperty("children")) ? 'hasChildren' : ''}>
													<Link href={item.href} activeClassName="active" target={item.target}><Typography variant="header">{item.text}</Typography></Link>
													{submenuLinks.length > 0 &&
														<ul className="dropdownMenu">
															{submenuLinks.map((subLink, subIndex) => {
																return (
																	<li><Link key={subIndex} href={subLink.href} activeClassName="active" target={subLink.target}><Typography variant="dropdown-menu">{subLink.text}</Typography></Link></li>
																)
															})}
														</ul>
													}
												</li>
												)
											})}
									</ul>
								</nav>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Box>
		</header>
		<MobileMenu open={showMobileMenu} anchor={anchorEl} onClose={closeMenu}/>
		</>
	)
}

export default Header;